export enum NftRarity {
  Unlimited = 'unlimited',
  Common = 'common',
  Rare = 'rare',
  Holo = 'holo',
  Platinum = 'platinum',
  Unique = 'unique',
}
